@use 'src/styles/variables-bundle' as *;

:host {
  text-align: left;
}
